/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class ScrappedReasonClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * deleteScrappedReason
     * @param ids ids
     * @return OK
     */
    deleteScrappedReason(ids: string[]): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/client/openapi/delete/scrappedReason?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteScrappedReason(_response);
        });
    }

    protected processDeleteScrappedReason(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * getPageScrappedReason
     * @param scrappedReasonPageDTO scrappedReasonPageDTO
     * @return OK
     */
    getPageScrappedReason(scrappedReasonPageDTO: ScrappedReasonPageDTO): Promise<ROfBladePageOfScrappedReason> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/client/openapi/get/scrappedReason/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scrappedReasonPageDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageScrappedReason(_response);
        });
    }

    protected processGetPageScrappedReason(response: AxiosResponse): Promise<ROfBladePageOfScrappedReason> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfBladePageOfScrappedReason.fromJS(resultData200) : new ROfBladePageOfScrappedReason();
            return result200;
        }
        return Promise.resolve<ROfBladePageOfScrappedReason>(<any>null);
    }
}

export class ScrappedTypeClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * deleteScrappedType
     * @param ids ids
     * @return OK
     */
    deleteScrappedType(ids: string[]): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/client/openapi/delete/scrappedType?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteScrappedType(_response);
        });
    }

    protected processDeleteScrappedType(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * getPageScrappedType
     * @param scrappedTypePageDTO scrappedTypePageDTO
     * @return OK
     */
    getPageScrappedType(scrappedTypePageDTO: ScrappedTypePageDTO): Promise<ROfBladePageOfScrappedType> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/client/openapi/scrappedType/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scrappedTypePageDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageScrappedType(_response);
        });
    }

    protected processGetPageScrappedType(response: AxiosResponse): Promise<ROfBladePageOfScrappedType> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfBladePageOfScrappedType.fromJS(resultData200) : new ROfBladePageOfScrappedType();
            return result200;
        }
        return Promise.resolve<ROfBladePageOfScrappedType>(<any>null);
    }
}

export class ScrappedReasonServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取单个报废原因
     * @param id id
     * @return OK
     */
    qcGetScrappedReason(id: string): Promise<ScrappedReasonVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/scrapped-reason?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQcGetScrappedReason(_response);
        });
    }

    protected processQcGetScrappedReason(response: AxiosResponse): Promise<ScrappedReasonVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ScrappedReasonVO.fromJS(resultData200) : new ScrappedReasonVO();
            return result200;
        }
        return Promise.resolve<ScrappedReasonVO>(<any>null);
    }

    /**
     * 新建报废原因
     * @param dto dto
     * @return OK
     */
    qcSaveScrappedReason(dto: ScrappedReasonDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/scrapped-reason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQcSaveScrappedReason(_response);
        });
    }

    protected processQcSaveScrappedReason(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 更新报废原因
     * @param dto dto
     * @return OK
     */
    qcUpdateScrappedReason(dto: ScrappedReasonDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/scrapped-reason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQcUpdateScrappedReason(_response);
        });
    }

    protected processQcUpdateScrappedReason(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除报废原因
     * @param ids ids
     * @return OK
     */
    qcDeleteScrappedReason(ids: string[]): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/scrapped-reason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQcDeleteScrappedReason(_response);
        });
    }

    protected processQcDeleteScrappedReason(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询报废原因
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param typeId (optional) typeId
     * @return OK
     */
    qcGetPageScrappedReason(current: number | null | undefined, size: number | null | undefined, typeId: string | null | undefined): Promise<IPageOfScrappedReasonVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/scrapped-reason/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQcGetPageScrappedReason(_response);
        });
    }

    protected processQcGetPageScrappedReason(response: AxiosResponse): Promise<IPageOfScrappedReasonVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfScrappedReasonVO.fromJS(resultData200) : new IPageOfScrappedReasonVO();
            return result200;
        }
        return Promise.resolve<IPageOfScrappedReasonVO>(<any>null);
    }
}

export class ScrappedTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取报废类型
     * @param id id
     * @return OK
     */
    getScrappedType(id: string): Promise<ScrappedTypeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/scrapped-type?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetScrappedType(_response);
        });
    }

    protected processGetScrappedType(response: AxiosResponse): Promise<ScrappedTypeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ScrappedTypeVO.fromJS(resultData200) : new ScrappedTypeVO();
            return result200;
        }
        return Promise.resolve<ScrappedTypeVO>(<any>null);
    }

    /**
     * 新建报废类型
     * @param dto dto
     * @return OK
     */
    saveScrappedType(dto: ScrappedTypeDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/scrapped-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveScrappedType(_response);
        });
    }

    protected processSaveScrappedType(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 更新报废类型
     * @param dto dto
     * @return OK
     */
    updateScrappedType(dto: ScrappedTypeDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/scrapped-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateScrappedType(_response);
        });
    }

    protected processUpdateScrappedType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除报废类型
     * @param ids ids
     * @return OK
     */
    deleteScrappedType(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/scrapped-type?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteScrappedType(_response);
        });
    }

    protected processDeleteScrappedType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 关键词和分页查询报废类型
     * @param current (optional) 当前页
     * @param keyWord (optional) keyWord
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageScrappedReason(current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfScrappedTypeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/scrapped-type/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageScrappedReason(_response);
        });
    }

    protected processGetPageScrappedReason(response: AxiosResponse): Promise<IPageOfScrappedTypeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfScrappedTypeVO.fromJS(resultData200) : new IPageOfScrappedTypeVO();
            return result200;
        }
        return Promise.resolve<IPageOfScrappedTypeVO>(<any>null);
    }
}

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-qc')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class BladePageOfScrappedReason implements IBladePageOfScrappedReason {
    current!: string | undefined;
    records!: ScrappedReason[] | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IBladePageOfScrappedReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ScrappedReason.fromJS(item));
            }
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): BladePageOfScrappedReason {
        data = typeof data === 'object' ? data : {};
        let result = new BladePageOfScrappedReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IBladePageOfScrappedReason {
    current: string | undefined;
    records: ScrappedReason[] | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class BladePageOfScrappedType implements IBladePageOfScrappedType {
    current!: string | undefined;
    records!: ScrappedType[] | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IBladePageOfScrappedType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ScrappedType.fromJS(item));
            }
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): BladePageOfScrappedType {
        data = typeof data === 'object' ? data : {};
        let result = new BladePageOfScrappedType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IBladePageOfScrappedType {
    current: string | undefined;
    records: ScrappedType[] | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class IPageOfScrappedReasonVO implements IIPageOfScrappedReasonVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ScrappedReasonVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfScrappedReasonVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ScrappedReasonVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfScrappedReasonVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfScrappedReasonVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfScrappedReasonVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ScrappedReasonVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfScrappedTypeVO implements IIPageOfScrappedTypeVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ScrappedTypeVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfScrappedTypeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ScrappedTypeVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfScrappedTypeVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfScrappedTypeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfScrappedTypeVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ScrappedTypeVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

/** 返回信息 */
export class ROfBladePageOfScrappedReason implements IROfBladePageOfScrappedReason {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: BladePageOfScrappedReason | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfBladePageOfScrappedReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? BladePageOfScrappedReason.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfBladePageOfScrappedReason {
        data = typeof data === 'object' ? data : {};
        let result = new ROfBladePageOfScrappedReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfBladePageOfScrappedReason {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: BladePageOfScrappedReason | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfBladePageOfScrappedType implements IROfBladePageOfScrappedType {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: BladePageOfScrappedType | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfBladePageOfScrappedType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? BladePageOfScrappedType.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfBladePageOfScrappedType {
        data = typeof data === 'object' ? data : {};
        let result = new ROfBladePageOfScrappedType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfBladePageOfScrappedType {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: BladePageOfScrappedType | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfboolean implements IROfboolean {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: boolean | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfboolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfboolean {
        data = typeof data === 'object' ? data : {};
        let result = new ROfboolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfboolean {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: boolean | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class ScrappedReason implements IScrappedReason {
    /** 报废原因编号 */
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 报废原因 */
    reason!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 所属租户ID */
    tenantId!: string | undefined;
    /** 报废类型ID */
    typeId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IScrappedReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.reason = data["reason"];
            this.remark = data["remark"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.typeId = data["typeId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): ScrappedReason {
        data = typeof data === 'object' ? data : {};
        let result = new ScrappedReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["typeId"] = this.typeId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IScrappedReason {
    /** 报废原因编号 */
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 报废原因 */
    reason: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 所属租户ID */
    tenantId: string | undefined;
    /** 报废类型ID */
    typeId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class ScrappedReasonDTO implements IScrappedReasonDTO {
    /** 报废原因编号 */
    code!: string;
    /** 报废原因 */
    reason!: string;
    /** 备注 */
    remark!: string | undefined;
    /** 报废类型ID */
    typeId!: string;

    constructor(data?: IScrappedReasonDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.reason = data["reason"];
            this.remark = data["remark"];
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): ScrappedReasonDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScrappedReasonDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface IScrappedReasonDTO {
    /** 报废原因编号 */
    code: string;
    /** 报废原因 */
    reason: string;
    /** 备注 */
    remark: string | undefined;
    /** 报废类型ID */
    typeId: string;
}

export class ScrappedReasonPageDTO implements IScrappedReasonPageDTO {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;
    /** 类型id */
    typeId!: string;

    constructor(data?: IScrappedReasonPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): ScrappedReasonPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScrappedReasonPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface IScrappedReasonPageDTO {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
    /** 类型id */
    typeId: string;
}

export class ScrappedReasonVO implements IScrappedReasonVO {
    /** 报废原因编号 */
    code!: string | undefined;
    /** 报废原因id */
    id!: string | undefined;
    /** 报废原因 */
    reason!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IScrappedReasonVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.reason = data["reason"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): ScrappedReasonVO {
        data = typeof data === 'object' ? data : {};
        let result = new ScrappedReasonVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IScrappedReasonVO {
    /** 报废原因编号 */
    code: string | undefined;
    /** 报废原因id */
    id: string | undefined;
    /** 报废原因 */
    reason: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class ScrappedType implements IScrappedType {
    /** 报废类型编号 */
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 报废类型名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 所属租户ID */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IScrappedType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): ScrappedType {
        data = typeof data === 'object' ? data : {};
        let result = new ScrappedType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IScrappedType {
    /** 报废类型编号 */
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 报废类型名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 所属租户ID */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class ScrappedTypeDTO implements IScrappedTypeDTO {
    /** 报废类型编号 */
    code!: string;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 报废类型名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IScrappedTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): ScrappedTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScrappedTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IScrappedTypeDTO {
    /** 报废类型编号 */
    code: string;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 报废类型名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class ScrappedTypePageDTO implements IScrappedTypePageDTO {
    /** 当前页 */
    current!: number | undefined;
    /** 关键字 */
    keyWord!: string | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IScrappedTypePageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.keyWord = data["keyWord"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): ScrappedTypePageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScrappedTypePageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["keyWord"] = this.keyWord;
        data["size"] = this.size;
        return data; 
    }
}

export interface IScrappedTypePageDTO {
    /** 当前页 */
    current: number | undefined;
    /** 关键字 */
    keyWord: string | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

export class ScrappedTypeVO implements IScrappedTypeVO {
    /** 报废类型编号 */
    code!: string | undefined;
    /** 报废类型id */
    id!: string | undefined;
    /** 报废类型 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IScrappedTypeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): ScrappedTypeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ScrappedTypeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IScrappedTypeVO {
    /** 报废类型编号 */
    code: string | undefined;
    /** 报废类型id */
    id: string | undefined;
    /** 报废类型 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}